<template>
  <v-container id="results" v-if="showTableCards">
    <v-row >
      <v-col cols="12" sm="12">
        <v-img contain class="mx-auto" max-height="150px" v-bind:src="this.getResult()" />
      </v-col>
    </v-row>
    
    <div id="redo">
      <v-chip v-on:click="refresh()" class="ma-2" :color="getColor()" outlined>
        Revote
        <v-icon right>{{mdiRefresh}}</v-icon>
      </v-chip>
    </div>
  </v-container>
</template>

<script>
import { mdiRefresh } from '@mdi/js'

export default {
  name: 'results',
  data () {
    return {
      mdiRefresh
    }
  },
  props: {
    showTableCards: Boolean,
    mode: String,
    table: Object,
    tableId: String
  },
  methods: {
    refresh: function () {
      this.$socket.emit('mode', { tableId: this.tableId, value: this.mode })
    },
    getCardImage: function (name, series) {
      return require('@/assets/cards/' + series + '/' + name + '.png')
    },
    closest: function (values, goal) {
      return values.reduce(function(prev, curr) {
        return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
      });
    },
    itsChristmas: function () {
      return this.$store.state.holidaysMode === 'christmas'
    },
    itsEaster: function () {
      return this.$store.state.holidaysMode === 'easter'
    },
    getColor: function() {
      if(this.itsChristmas())
        return "#F44336"
      else if (this.itsEaster())
        return "#FFC107"
      return "#4676be"
    },
    getCardAvg: function () {
      const cards = Object.entries(this.table).map(el => el[1])
      
      if(cards.some(el => el.name === 'question'))
        return -1
      if(cards.some(el => el.name === 'infinite'))
        return -2

      const votes = cards
        .filter(el => el.value !== null)
        .map(el => el.value)

      const sum = votes.reduce((a, b) => a + b, 0)
      const avg = (sum / votes.length) || 0

      return avg;
    },
    getResult: function () {
      const avg = this.getCardAvg()

      if (this.mode === 'fibonacci') {
        if(avg === -1)
          return this.getCardImage('question', 'fibonacci')
        if(avg === -2)
          return this.getCardImage('infinite', 'fibonacci')

        const imageNumber = this.closest([1, 2, 3, 5, 8, 13, 20, 40, 100], avg)

        if(avg > 0)
          return this.getCardImage(imageNumber, 'fibonacci')
        return this.getCardImage('question', 'fibonacci')
      }
      else if (this.mode === 'tshirt') {
        const imageNumber = this.closest([1, 2, 3, 4, 5], avg)
        if(avg < 1)
          return 

        switch (imageNumber) {
          case 1: return this.getCardImage('xs', 'tshirt')
          case 2: return this.getCardImage('s', 'tshirt')
          case 3: return this.getCardImage('m', 'tshirt')
          case 4: return this.getCardImage('l', 'tshirt')
          case 5: return this.getCardImage('xl', 'tshirt')
        }
      }
      else {
        const imageNumber = this.closest([1, 2, 3, 4, 5], avg)
        if(avg < 1)
          return 

        switch (imageNumber) {
          case 1: return this.getCardImage('up', 'thumbs')
          case 2: return this.getCardImage('middle-up', 'thumbs')
          case 3: return this.getCardImage('middle', 'thumbs')
          case 4: return this.getCardImage('middle-down', 'thumbs')
          case 5: return this.getCardImage('down', 'thumbs')
        }
      }
    }
  }
}
</script>

<style scoped>
#results {
  color: black;
}

#redo {
  margin-top: 2%;
}
</style>
